import { StateType } from '../index';

export const expressionFetchingSelector = (state: StateType) => state.getIn(['expression', 'fetching']) as boolean;

export const expressionOperatorsSelector = (state: StateType) => state.getIn(['expression', 'operators']);
